<template>
  <a 
    href="#" 
    v-if="show" 
    @click.prevent="lock"
    :class="{'muted': isEveryPageLocked }"
  >
    <aw-icon icon="lock" class="w-5 h-5 "></aw-icon>
    {{$t('Lock')}}
  </a>
  <right-menu-item
    v-if="show && (lockedList.length > 0 || isEveryPageLocked)"
    @click.prevent="releaseLock"
    :class="{'muted': lockedList.length === 0 && !isEveryPageLocked }"
    :text="$t('Unlock')"
    :loading="loading"
    icon="lock"
  />
</template>

<script>
import { mapStores } from 'pinia'
import useBcDocumentStore from '@/frontapp/store/bcDocument'
import useBcSelectedStore from '@/frontapp/store/bcSelected'
import assign from 'lodash/assign'
import { DocumentApi } from '../../test-api/index.ts'
import { trackEvent } from '../../gtm'

const documentApi = new DocumentApi({}, '/api/v2')

export default {
  data() {
    return {
      loading: false,
    }
  },
  computed: {
    show () {
      return this.bcDocumentStore.document.can_edit && this.bcDocumentStore.edit
    },
    isEveryPageLocked() {
      let hasPages = false
      this.bcDocumentStore.document?.children?.forEach(e => {
        if (!e.locked) {
          return false
        }
        hasPages = true
      })

      return hasPages
    },
    lockedList () {
      return this.listCanLock.filter((e) => e.locked)
    },
    lockList () {
      return this.listCanLock.filter((e) => !e.locked)
    },
    listCanLock () {
      const elementIds = this.bcSelectedStore.listFullySelected.map((el) => el.id)
      return this.bcSelectedStore.listFullySelected.filter((el) => {
        return (!el.parent__bc_document_data_rev_id || !elementIds.includes(el.parent__bc_document_data_rev_id))
          && el.type !== 'file'
          && el.type !== 'table-row'
          && el.type !== 'color-row'
      })
    },
    ...mapStores(useBcDocumentStore, useBcSelectedStore),
  },
  methods: {
    lock() {
      let elementsToLock = []

      const lockedPages = this.listCanLock.filter((e) => e.type === 'page')
      const selectablePages = this.bcDocumentStore.document.children

      if (!this.listCanLock.length || lockedPages.length === selectablePages.length) {
        elementsToLock = this.bcSelectedStore.selectableMap
      } else {
        elementsToLock = this.lockList
      }

      elementsToLock.forEach((el) => {
        const docEl = this.bcDocumentStore.findElementInDocument(el.id)
        docEl.oldType = docEl.type
        docEl.type = 'locked'
      })

      this.bcSelectedStore.reload()
      trackEvent(this.$route.matched[0].name, 'lock')
    },
    releaseLock() {
      if (this.isEveryPageLocked) {
        this.releaseLockDocument()
      } else {
        this.releaseLockElement()
      }
      trackEvent(this.$route.matched[0].name, 'releaseLock')
    },
    releaseLockDocument() {
      this.loading = true
      this.bcDocumentStore.addToUpdateQueue(() => new Promise((resolve/*, reject*/) => {
        documentApi.documentReleaseLock(
          this.bcDocumentStore.document.id,
          this.bcDocumentStore.document.bc_document_rev_id,
        ).then((data) => {
          if (data.data.bc_document_rev_id !== this.bcDocumentStore.document.bc_document_rev_id) {
            this.bcDocumentStore.willChangeRevision = true
            this.$router.replace({ 
              name: 'BCDocumentDetailRev',
              params: { revId: data.data.bc_document_rev_id } 
            }).then(() => {
              resolve()
            })
          } else {
            this.bcDocumentStore.setDocument(data.data)
            this.bcSelectedStore.reload()
            resolve()
          }
          this.loading = false
        })
      }))
    },
    releaseLockElement() {
      this.lockedList.forEach((el) => {
        if (el.oldType) {
          const docEl = this.bcDocumentStore.findElementInDocument(el.id)
          docEl.type = docEl.oldType
          delete docEl.oldType
          return
        }

        this.loading = true
        this.bcDocumentStore.addToUpdateQueue(() => new Promise((resolve/*, reject*/) => {
          documentApi.elementReleaseLock(
            this.bcDocumentStore.document.id,
            this.bcDocumentStore.document.bc_document_rev_id,
            el.id,
          ).then((data) => {
            if (data.data.bc_document_rev_id !== this.bcDocumentStore.document.bc_document_rev_id) {
              this.bcDocumentStore.willChangeRevision = true
              this.$router.replace({ 
                name: 'BCDocumentDetailRev',
                params: { revId: data.data.bc_document_rev_id } 
              }).then(() => {
                resolve()
              })
            } else {
              const docEl = this.bcDocumentStore.findElementInDocument(el.id)
              this.bcDocumentStore.removeFromFlatten(docEl)
              assign(docEl, data.data)
              this.bcDocumentStore.addToFlatten(docEl)
              this.bcSelectedStore.resetSelected()
              resolve()
            }
            this.loading = false
          })
        }))
      })
    }
  }
}
</script>

<style lang="scss" scoped></style>
